"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerSubOrgSelectionErrorCode = void 0;
var PartnerSubOrgSelectionErrorCode;
(function (PartnerSubOrgSelectionErrorCode) {
    PartnerSubOrgSelectionErrorCode["notRequired"] = "notRequired";
    PartnerSubOrgSelectionErrorCode["subOrgNotSelectable"] = "subOrgNotSelectable";
    PartnerSubOrgSelectionErrorCode["selectionLocked"] = "selectionLocked";
})(PartnerSubOrgSelectionErrorCode || (exports.PartnerSubOrgSelectionErrorCode = PartnerSubOrgSelectionErrorCode = {}));
